/* BABYGO product story template: sticky nav offsets, smooth scrolling, hero video, gallery, dialogs, mobile buy bar.
   Every section on the template includes this file; the guard below makes it run once. */
(function () {
  'use strict';
  if (window.__pdpStory) return;
  window.__pdpStory = true;

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cssPx(name) {
    return parseFloat(getComputedStyle(root).getPropertyValue(name)) || 0;
  }

  /* Offsets: the theme header is position: sticky, the product nav sticks directly under it. */
  function measure() {
    var header = document.querySelector('.header-section');
    var top = 0;
    if (header) {
      var pos = getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') top = header.getBoundingClientRect().height;
    }
    root.style.setProperty('--pdp-sticky-top', top + 'px');
    var nav = document.querySelector('.pdp-nav-section');
    root.style.setProperty('--pdp-nav-h', (nav ? nav.getBoundingClientRect().height : 0) + 'px');
  }

  var frame = false;
  function onScroll() {
    if (frame) return;
    frame = true;
    requestAnimationFrame(function () {
      frame = false;
      measure();
      updateActiveLink();
      updateStickyBar();
    });
  }

  /* Smooth scroll to a section, allowing for the sticky header and nav. */
  function scrollToId(id, focus) {
    var el = document.getElementById(id);
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.pageYOffset - cssPx('--pdp-sticky-top') - cssPx('--pdp-nav-h');
    window.scrollTo({ top: Math.max(0, y), behavior: reduced.matches ? 'auto' : 'smooth' });
    if (focus) {
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      el.focus({ preventScroll: true });
    }
    return true;
  }

  function afterScroll(cb) {
    if (reduced.matches) { setTimeout(cb, 150); return; }
    var done = false;
    var finish = function () { if (done) return; done = true; window.removeEventListener('scrollend', finish); setTimeout(cb, 120); };
    if ('onscrollend' in window) window.addEventListener('scrollend', finish, { once: true });
    setTimeout(finish, 900);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.pdp a[href^="#"], .pdp-sticky a[href^="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.length < 2) return;
    var target = document.getElementById(href.slice(1));
    if (target && target.tagName === 'DIALOG' && typeof target.showModal === 'function') {
      e.preventDefault();
      openDialog(target);
      return;
    }
    if (scrollToId(href.slice(1), true)) {
      e.preventDefault();
      if (history.replaceState) history.replaceState(null, '', href);
      closeNav();
      var after = a.getAttribute('data-pdp-open-after');
      if (after) {
        var dlg = document.getElementById(after);
        if (dlg && typeof dlg.showModal === 'function') afterScroll(function () { openDialog(dlg); });
      }
    }
  });

  /* Product nav: mobile dropdown and active section. */
  var nav = document.querySelector('.pdp-nav');
  var navLinks = nav ? Array.prototype.slice.call(nav.querySelectorAll('.pdp-nav__links a[href^="#"]')) : [];
  var navTargets = navLinks.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });

  function closeNav() {
    if (!nav) return;
    nav.classList.remove('is-open');
    var t = nav.querySelector('.pdp-nav__toggle');
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  if (nav) {
    var toggle = nav.querySelector('.pdp-nav__toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('is-open') && !nav.contains(e.target)) closeNav();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });
  }
  function updateActiveLink() {
    if (!navLinks.length) return;
    var line = cssPx('--pdp-sticky-top') + cssPx('--pdp-nav-h') + 12;
    var current = null;
    navTargets.forEach(function (t) {
      if (t && t.getBoundingClientRect().top <= line) current = t;
    });
    navLinks.forEach(function (a) {
      a.classList.toggle('is-active', !!current && a.getAttribute('href') === '#' + current.id);
    });
  }

  /* Hero video: play whichever variant the stylesheet is showing, pause off screen. */
  document.querySelectorAll('[data-pdp-hero-video]').forEach(function (wrapper) {
    var variants = Array.prototype.slice.call(wrapper.querySelectorAll('[data-pdp-variant]'));
    if (!variants.length) return;
    var active = null;
    var inView = true;
    function visibleVideo() {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].offsetParent !== null || getComputedStyle(variants[i]).display !== 'none') {
          var v = variants[i].querySelector('video');
          if (v) return v;
        }
      }
      return null;
    }
    function sync() {
      var v = visibleVideo();
      if (v !== active) {
        if (active) active.pause();
        active = v;
      }
      if (!active) return;
      if (inView && !reduced.matches) {
        active.muted = true;
        var p = active.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        active.pause();
      }
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.05 }).observe(wrapper);
    }
    window.addEventListener('resize', sync);
    if (reduced.addEventListener) reduced.addEventListener('change', sync);
    sync();
  });

  /* Clips: a still with the video behind it. Tap to play on touch screens, hover on desktop; the clip rests
     on its last frame with a replay control, and leaving the tile on desktop puts the still back. */
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  function bindClip(el) {
    var v = el.querySelector('video');
    var btn = el.querySelector('.pdp-clip__btn');
    if (!v || !btn) return;
    var state = 'idle';
    function set(s) {
      state = s;
      el.classList.toggle('is-playing', s === 'playing');
      el.classList.toggle('is-ended', s === 'ended');
      btn.setAttribute('aria-label', s === 'ended' ? 'Play again' : btn.getAttribute('data-label-play'));
    }
    btn.setAttribute('data-label-play', btn.getAttribute('aria-label'));
    function play() {
      state = 'loading';
      var p = v.play();
      if (p && p.catch) p.catch(function () { if (state === 'loading') set('idle'); });
    }
    function restart() {
      try { v.currentTime = 0; } catch (err) {}
      play();
    }
    function reset() {
      v.pause();
      try { v.currentTime = 0; } catch (err) {}
      set('idle');
    }
    v.addEventListener('playing', function () { if (state !== 'idle') set('playing'); else v.pause(); });
    v.addEventListener('ended', function () { set('ended'); });
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (state === 'ended') restart(); else if (state === 'idle') play();
    });
    el.addEventListener('click', function () {
      if (state === 'ended') restart(); else if (state === 'idle') play();
    });
    if (canHover.matches && !reduced.matches) {
      el.addEventListener('pointerenter', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        if (state === 'idle') play();
      });
      el.addEventListener('pointerleave', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        if (state !== 'idle') reset();
      });
    }
  }
  document.querySelectorAll('[data-pdp-clip]').forEach(bindClip);

  /* Buy module gallery. */
  function bindGallery(g) {
    var track = g.querySelector('[data-pdp-track]');
    var slides = Array.prototype.slice.call(g.querySelectorAll('.pdp-gallery__slide'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('.pdp-thumb'));
    var thumbStrip = g.querySelector('.pdp-gallery__thumbs');
    var current = 0;
    function setActive(i, fromScroll) {
      if (i < 0 || i >= slides.length) return;
      current = i;
      thumbs.forEach(function (x, j) {
        var on = j === i;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      slides.forEach(function (s, j) {
        var v = s.querySelector('video');
        if (!v) return;
        if (j === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
      if (thumbStrip && thumbs[i]) {
        var t = thumbs[i];
        var left = t.offsetLeft - (thumbStrip.clientWidth - t.offsetWidth) / 2;
        thumbStrip.scrollTo({ left: Math.max(0, left), behavior: reduced.matches ? 'auto' : 'smooth' });
      }
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (track) track.scrollTo({ left: i * track.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth' });
        setActive(i);
      });
    });
    if (track) {
      var pending = false;
      track.addEventListener('scroll', function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current) setActive(i, true);
        });
      }, { passive: true });
    }
  }
  function bindGalleries(scope) {
    (scope || document).querySelectorAll('[data-pdp-gallery]').forEach(bindGallery);
  }
  bindGalleries(document);

  /* Colour switching: each colour is its own product, so the buy module is re-rendered for that
     product through Shopify's section rendering and swapped in place. Links still work without JS. */
  function markSelected(handle) {
    document.querySelectorAll('.pdp-colour').forEach(function (li) {
      var a = li.querySelector('[data-pdp-select]');
      var on = !!a && a.getAttribute('data-handle') === handle;
      li.classList.toggle('is-selected', on);
      if (a) { if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); }
    });
  }
  var switching = false;
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-pdp-select]');
    if (!a) return;
    var buy = document.querySelector('[data-pdp-buy]');
    if (!buy || !window.fetch || !window.DOMParser) return;
    var url = a.getAttribute('data-pdp-select');
    var handle = a.getAttribute('data-handle');
    if (!url || !handle) return;
    e.preventDefault();
    if (handle === buy.getAttribute('data-product-handle')) { markSelected(handle); return; }
    if (switching) return;
    switching = true;
    buy.classList.add('is-switching');
    buy.setAttribute('aria-busy', 'true');
    var sid = buy.getAttribute('data-section-id');
    var view = buy.getAttribute('data-view');
    var q = url + '?section_id=' + encodeURIComponent(sid) + (view ? '&view=' + encodeURIComponent(view) : '');
    fetch(q, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-pdp-buy]');
        if (!fresh) throw new Error('missing');
        var node = document.importNode(fresh, true);
        var current = document.querySelector('[data-pdp-buy]');
        var wrapper = current.parentNode;
        current.replaceWith(node);
        var oldLd = wrapper.querySelector('script[type="application/ld+json"]');
        var newLd = doc.querySelector('script[type="application/ld+json"]');
        if (oldLd && newLd) {
          var s = document.createElement('script');
          s.type = 'application/ld+json';
          s.textContent = newLd.textContent;
          oldLd.replaceWith(s);
        }
        bindGalleries(node);
        markSelected(handle);
        if (history.replaceState) history.replaceState(null, '', url + location.search + location.hash);
      })
      .catch(function () { location.href = url + '#' + (buy.id || 'buy'); })
      .then(function () {
        switching = false;
        var b = document.querySelector('[data-pdp-buy]');
        if (b) { b.classList.remove('is-switching'); b.removeAttribute('aria-busy'); }
      });
  });

  /* Dialogs: fit guide video, all reviews. */
  function visibleVideoIn(d) {
    var vids = Array.prototype.slice.call(d.querySelectorAll('video'));
    for (var i = 0; i < vids.length; i++) {
      if (vids[i].offsetParent !== null) return vids[i];
    }
    return null;
  }
  function openDialog(d) {
    d.showModal();
    document.body.classList.add('pdp-dialog-open');
    var v = visibleVideoIn(d);
    if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }
  document.querySelectorAll('[data-pdp-dialog-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var d = document.getElementById(btn.getAttribute('data-pdp-dialog-open'));
      if (!d || typeof d.showModal !== 'function') return;
      e.preventDefault();
      openDialog(d);
    });
  });
  document.querySelectorAll('dialog.pdp-dialog').forEach(function (d) {
    d.querySelectorAll('[data-pdp-dialog-close]').forEach(function (b) {
      b.addEventListener('click', function () { d.close(); });
    });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.addEventListener('close', function () {
      document.body.classList.remove('pdp-dialog-open');
      d.querySelectorAll('video').forEach(function (v) { v.pause(); });
    });
  });

  /* Mobile sticky buy bar: shows once the hero buttons scroll away, hides once the buy module is in reach. */
  var bar = document.querySelector('.pdp-sticky');
  var heroActions = document.querySelector('.pdp-hero__actions');
  var buyPanel = document.querySelector('.pdp-buy__panel');
  function updateStickyBar() {
    if (!bar) return;
    var show = window.innerWidth < 900;
    if (show && heroActions) show = heroActions.getBoundingClientRect().bottom < 0;
    if (show && buyPanel) show = buyPanel.getBoundingClientRect().top > window.innerHeight - 80;
    bar.classList.toggle('is-visible', show);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', onScroll);
  measure();
  updateActiveLink();
  updateStickyBar();

  /* Land on the right spot when arriving with a hash (e.g. a colour swatch link to #buy). */
  if (location.hash && location.hash.length > 1) {
    window.addEventListener('load', function () {
      setTimeout(function () { scrollToId(location.hash.slice(1), false); }, 60);
    });
  }
})();
